import { useState } from "react";

interface ReasonDialogProps {
  title: string;
  confirmLabel: string;
  placeholder: string;
  busy: boolean;
  onConfirm: (reason: string) => void;
  onCancel: () => void;
}

export default function ReasonDialog({
  title,
  confirmLabel,
  placeholder,
  busy,
  onConfirm,
  onCancel,
}: ReasonDialogProps) {
  const [reason, setReason] = useState("");

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center px-4">
      <div
        className="absolute inset-0 bg-black/40"
        onClick={onCancel}
        aria-hidden
      ></div>
      <div className="relative w-full max-w-md rounded-lg border border-background-200 bg-background-50 p-5">
        <h3 className="font-heading text-base font-bold text-foreground-950">
          {title}
        </h3>
        <p className="mt-1 text-sm text-foreground-500">
          El motivo quedará registrado y se le informará al vendedor.
        </p>
        <textarea
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          maxLength={500}
          rows={3}
          placeholder={placeholder}
          className="mt-4 w-full resize-none rounded-md border border-background-200 bg-background-50 px-3.5 py-2.5 text-sm text-foreground-900 outline-none transition-colors placeholder:text-foreground-400 focus:border-primary-400 focus:ring-2 focus:ring-primary-100"
        />
        <p className="mt-1 text-right text-xs text-foreground-400">
          {reason.length}/500
        </p>
        <div className="mt-5 flex items-center justify-end gap-2">
          <button
            type="button"
            onClick={onCancel}
            className="inline-flex cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md border border-background-200 bg-background-50 px-4 py-2 text-sm font-semibold text-foreground-700 transition-colors hover:bg-background-100"
          >
            Cancelar
          </button>
          <button
            type="button"
            onClick={() => onConfirm(reason.trim())}
            disabled={busy || !reason.trim()}
            className="inline-flex cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md bg-accent-500 px-4 py-2 text-sm font-semibold text-white transition-colors hover:bg-accent-600 disabled:cursor-not-allowed disabled:opacity-60"
          >
            {busy && <i className="ri-loader-4-line animate-spin"></i>}
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}